/* EmojiPickerNoResults.tsx generated by @compiled/babel-plugin v0.40.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulppxbi%7Bgap%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx21bp4%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0q1ejb%7Bpadding-top%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f3pxbi%7Bpadding-right%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3td1ejb%7Bpadding-bottom%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bvpxbi%7Bpadding-left%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y3gn1h6o%7Btext-align%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
import { useCallback, type MouseEvent } from 'react';
import { useThemeObserver } from '@atlaskit/tokens/use-theme-observer';
import { fg } from '@atlaskit/platform-feature-flags';
import { FormattedMessage } from 'react-intl';
import AkButton from '@atlaskit/button/standard-button';
import { messages } from '../i18n';
import SearchNoResultDark from './assets/spot/search-no-result/SearchNoResultDark';
import SearchNoResultLight from './assets/spot/search-no-result/SearchNoResultLight';
const noResultsContainer = null;
export const RENDER_EMOJI_PICKER_NO_RESULTS_TESTID = 'render-emoji-picker-no-results';
export interface Props {
  onOpenUpload: () => void;
  uploadEnabled: boolean;
}
const EmojiPickerNoResults = ({
  onOpenUpload,
  uploadEnabled
}: Props): JSX.Element => {
  const {
    colorMode
  } = useThemeObserver();
  const handleOpenUpload = useCallback((event: MouseEvent<HTMLElement>) => {
    if (fg('platform_emoji_keep_picker_open_on_upload')) {
      event.preventDefault();
      event.stopPropagation();
    }
    onOpenUpload();
  }, [onOpenUpload]);
  return <div data-testid={RENDER_EMOJI_PICKER_NO_RESULTS_TESTID} className={ax(["_zulppxbi _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _ca0q1ejb _u5f3pxbi _n3td1ejb _19bvpxbi _y3gn1h6o _1bsb1osq _vchhusvi"])}>
			{colorMode === 'dark' ? <SearchNoResultDark /> : <SearchNoResultLight />}
			{uploadEnabled && <FormattedMessage {...messages.emojiPickerAddCustomEmoji}>
					{label => <AkButton onClick={handleOpenUpload} appearance="default" tabIndex={0}>
							{label}
						</AkButton>}
				</FormattedMessage>}
		</div>;
};
export default EmojiPickerNoResults;